// Section 9 and 7: Granary. 10 build points, 10 wood and 4 stone; +60 food capacity; food
// stored in it spoils 3% instead of 10% (25% if the granary is damaged). Theft and fire target.
// Constants: config.buildings.granary, config.resources.spoilage.food.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { buildingsOf } from '../../core/queries';
import {
  buildingEffectHook,
  capacityHook,
  combineModifiers,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function granary(config: Config) {
  const c = config.buildings.granary;

  return defineBuilding({
    id: 'granary',
    label: 'Granary',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: { food: c.foodCapacity },
    limit: { kind: 'none' },
    modifierTargets: ['capacity', 'spoilage', 'buildingEffect'],
    modifiers: combineModifiers(
      buildingEffectHook('granary'),
      capacityHook('granary', { food: c.foodCapacity }),
      (ctx, target) => {
        if (target.kind !== 'spoilage' || target.resource !== 'food') return [];
        const granaries = buildingsOf(ctx.state, 'granary');
        const amount = ctx.state.stocks.food.amount + ctx.state.seedReserved;
        if (granaries.length === 0 || amount <= 0) return [];
        let remaining = amount;
        let spoiled = 0;
        for (const g of granaries) {
          const held = Math.min(remaining, c.foodCapacity);
          const damaged = g.condition < config.building.fullEffectCondition;
          spoiled += held * (damaged ? c.damagedSpoilage : c.foodSpoilage);
          remaining -= held;
        }
        spoiled += remaining * config.resources.spoilage.food;
        return [mod.set('building:granary', spoiled / amount, 'stored in granary')];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
